import { render, staticRenderFns } from "./pay-slip3-id.vue?vue&type=template&id=6f89159c&"
import script from "./pay-slip3-id.vue?vue&type=script&lang=js&"
export * from "./pay-slip3-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports